//service.js
import { data } from 'jquery';
import service from './axios'

let development = process.env.NODE_ENV == 'development' ? true : false;
let baseURL = '/'
if(development){
	// baseURL = 'http://localhost:82/'
    // baseURL = 'https://rqxh.conjure.net.cn/'
    baseURL = 'https://gzsrqxh.cn/'
}

export let GetBaseURL = baseURL

export const Register = data => {
	return service({
		url: '/register',
		method: 'post',
		data
	})
};
// 发送验证码
export const SendSms = data => {
	return service({
		url: '/send_sms',
		method: 'post',
		data
	})
};
// 会员登录
export const Login = data => {
	return service({
		url: '/login',
		method: 'post',
		data
	})
};
// 专家登录
export const loginexpert = data => {
	return service({
		url: '/expert/login',
		method: 'post',
		data
	})
};
// 发送忘记密码验证码
export const SendForgetSms = data => {
	return service({
		url: '/send_forget_password_sms',
		method: 'post',
		data
	})
};
// 忘记密码提交
export const ForgetPassword = data => {
	return service({
		url: '/forget_password',
		method: 'post',
		data
	})
};
export const ChangePhone = data=>{
    return service({
        url: '/change_phone',
        method: 'post',
        data
    })
}
// 用户信息
export const GetMember = data => {
	return service({
		url: '/info',
		method: 'get',
		data
	})
};
// 专家登录信息
export const expertinfo = data => {
	return service({
		url: '/expert/info',
		method: 'get',
		data
	})
};
// 更新用户信息
export const UpdataMember = data => {
	return service({
		url: '/user',
		method: 'PUT',
		data:data
	})
};
// 奖项管理列表
export const PrizeList = data => {
	console.log(data)
	return service({
		url: '/prize',
		method: 'get',
		data
	})
};
// 新增奖项
export const AddPrize = data => {
	return service({
		url: '/prize',
		method: 'POST',
		data
	})
};
// 删除奖项
export const DelatePrize = id => {
	return service({
		url: '/prize/' + id,
		method: 'DELETE',

	})
};
// 申请会员
export const Apply = data => {
	return service({
		url: '/apply',
		method: 'POST',
		data:data,
	})
};
// 会员信息
export const ApplyInfo = data => {

	return service({
		url: '/apply/info',
		method: 'GET',
		data
	})
};
// 申请会员缴费
export const ApplyPayment = id => {
	return service({
		url: '/order/apply/' + id,
		method: 'POST',
	})
};
// 缴费记录
export const Order = data => {
	return service({
		url: '/order',
		method: 'GET',
		data
	})
};
//会员续费
export const renewOrder = id => {
	return service({
		url: '/order/renew',
		method: 'POST'
	})
};
// 订单信息
export const myOrder = id => {
	return service({
		url: `/order/${id}`,
		method: 'GET',
	})
};
// 奖项列表
export const AwardList = data => {
	return service({
		url: '/award',
		method: 'GET',
		data
	})
};
export const AwardListWithCount = data => {
	return service({
		url: '/awardCount',
		method: 'GET',
		data
	})
};
// 申报记录详情
export const AwardInfo = id => {
	return service({
		url: '/award_log/' + id,
		method: 'GET',
	})
};
export const AwardInfoList = data => {
	return service({
		url: '/award_log',
		method: 'GET',
		data
	})
};
// 申报奖项
export const AwardLog = data => {
	return service({
		url: '/award_log',
		method: 'POST',
		data
	})
};
// 申报奖项填写地址
export const Address = (id, address) => {

	return service({
		url: '/award_log/address/' + id,
		method: 'POST',
		data: {
			address
		}
	})
};

// 业绩申报列表
export const AchievementReport = data => {
	return service({
		url: '/achievement_report',
		method: 'GET',
		data
	})
};
// 申报业绩
export const AddAchievementReport = data => {
	return service({
		url: '/achievement_report',
		method: 'POST',
		data
	})
};

// 消息通知列表
export const Message = data => {
	return service({
		url: '/message',
		method: 'GET',
		data
	})
};
export const getMessageCount=()=>{
    return service({
        url: '/message/count',
        method: 'GET',
    })
}
// 标记已读, 不传标记全部, 传id则标记部分
export const MessageRead = data => {
	return service({
		url: '/message/read',
		method: 'POST',
		data
	})
};
export const PerformanceList = data =>{
	return service({
		url: '/association',
		method: 'GET',
		data
	})
}
export const PerformanceNextAndLast = data =>{
	return service({
		url: '/association/nextAndLast/'+data,
		method: 'GET'
	})
}
export const YearNotice = data =>{
	return service({
		url: '/yearnotice',
		method: 'GET',
		data
	})
}
export const UpdaeYearNotice = (id, data) => {
	return service({
		url: '/yearnotice/update/'+id,
		method: 'POST',
		data
	})
};
export const StoreYearNotice = (data) => {
	return service({
		url: '/yearnotice/store',
		method: 'POST',
		data
	})
};
// 申请发票
export const Invoice = (id, data) => {
	return service({
		url: '/invoice/' + id,
		method: 'POST',
		data
	})
};
//保存草稿
export const SaveDraft = (id, data) => {
	return service({
		url: '/award_log_temp',
		method: 'POST',
		data: {
			award_id: id,
			content: data
		}
	})
};
//保存草稿记录
export const Draftrecord = (id) => {
	return service({
		url: '/award_log_temp/' + id,
		method: 'GET'
	})
};
//申报
export const Declare = (id, data) => {
	return service({
		url: '/award_log',
		method: 'POST',
		data: {
			award_id: id,
			content: data
		}
	})
};
//申报驳回的
export const Declare_modify = (rId,id, data) => {
	if(rId&&rId!=0){
		return service({
			url: '/award_log',
			method: 'POST',
			data: {
				id:rId,
				award_id: id,
				content: data
			}
		})
	}
	else{
		return Declare(id,data);
	}
};
//申报记录详情
export const DeclareDetails = (id) => {
	return service({
		url: '/award_log/show/' + id,
		method: 'GET'
	})
};
//会员申请保存草稿
export const Memberdraft = (content) => {
	return service({
		url: '/apply_member_temp',
		method: 'POST',
		data: {
			content: content
		}
	})
};
//会员申请查看草稿详情
export const Memberdraftdetail = (content) => {
	return service({
		url: '/apply_member_temp',
		method: 'GET'
	})
};
//专家端奖项列表
export const expertaward = (data) => {
	return service({
		url: '/expert/award',
		method: 'GET',
		data
	})
};
//专家端奖项评审列表
export const expertawardlogs = id => {
	return service({
		url: '/expert/award/logs/'+id,
		method: 'GET'
	})
};
//专家端评审记录详情列表
export const expertverifyLogs = (id,data) => {
	return service({
		url: '/expert/award/verifyLogs/'+id,
		method: 'GET',
		data
	})
};
//专家端评审审核是否通过
export const expertverify = (data,id) => {
	return service({
		url: '/expert/award/verify/'+id,
		method: 'POST',
		data
	})
};
//会员申请表单详情
export const applydetail = (id) => {
	return service({
		url: '/apply/show/'+id,
		method: 'GET'
	})
};

//申请业绩申报列表
export const achievement = () => {
	return service({
		url: '/achievement',
		method: 'GET'
	})
};


//申请业绩申报详情
export const achievement_report = (id) => {
	return service({
		url: '/achievement_report/'+id,
		method: 'GET'
	})
};

//业绩申报草稿详情
export const achievement_report_temp_detail = (id) => {
	return service({
		url: '/achievement_report_temp/'+id,
		method: 'GET'
	})
};

//业绩申报草稿
export const achievement_report_temp = (data) => {
	return service({
		url: '/achievement_report_temp',
		method: 'POST',
		data
	})
};

//第二次提交奖项资料
export const submitFile = (data,id) => {
	return service({
		url: '/award_log/submitFile/'+id,
		method: 'POST',
		data
	})
};
//黄果树补充材料
export const submitFileHgs = (data,id) => {
	return service({
		url: '/award_log/submitFileHgs/'+id,
		method: 'POST',
		data
	})
};
